if (!customElements.get('lumora-cart-offer')) {
  customElements.define('lumora-cart-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('.lumora-cart-offer__select')) return;
        const option = event.target.selectedOptions[0];
        this.querySelector('[data-offer-price]').textContent = option.dataset.price;
        const original = this.querySelector('[data-offer-original]');
        if (original) original.textContent = option.dataset.original;
      });
    }
  });
}